var _path, _circle, _circle2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    stroke: "#CD2436",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.121 23.5C26.067 21.4 24.168 20 22 20c-3.314 0-6 3.274-6 7.313V29h8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 16,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 3.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27h2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgUserRemove;